import { UseGetOrganizationByIdReturnData } from '@/features/organization/hooks/useQuery/useGetOrganizationById';
import * as Sentry from '@sentry/react';

export function setOrganizationContext(organization?: UseGetOrganizationByIdReturnData | null) {
    const scope = Sentry.getCurrentScope();
        if (organization) {
            const {organisation_members, ...orgData} = organization;
            scope.setTag("orgId", organization.id);
            scope.setContext("organization", { ...orgData });
            scope.setContext("organizationMembers", Object.fromEntries(
                organisation_members?.map((member) => [member.id, member]) || []
            ));
        } else {
            scope.clear();
        }
}